export const FullHtmlCard = ({ content }) => {
  return (
    <div
      className="p-4 overflow-auto w-full h-full cursor-pointer"
      style={{
        backgroundColor: content?.background_color
          ? content.background_color
          : "#333333",
      }}
    >
      <div
        className="w-full h-full"
        dangerouslySetInnerHTML={{ __html: content.html_content }}
      />
    </div>
  );
};
